var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHybridappdevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smartphone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42 18h-20a3.009 3.009 0 0 0 -3 3v38a3.009 3.009 0 0 0 3 3h20a3.009 3.009 0 0 0 3-3v-38a3.009 3.009 0 0 0 -3-3zm-17 2h14v1a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1-1zm18 39a1 1 0 0 1 -1 1h-20a1 1 0 0 1 -1-1v-38a1 1 0 0 1 1-1h1v1a3.009 3.009 0 0 0 3 3h12a3.009 3.009 0 0 0 3-3v-1h1a1 1 0 0 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 52h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 52h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 56h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 56h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 36h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 38h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 28h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 50h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 42h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 38h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 48v-3a3 3 0 0 0 -3-3h-3v2h3a1 1 0 0 1 1 1v3a3 3 0 0 0 3 3h8v-2h-8a1 1 0 0 1 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 59v-1a3 3 0 0 0 -3-3h-7v2h7a1 1 0 0 1 1 1v1a3 3 0 0 0 3 3h4v-2h-4a1 1 0 0 1 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 45v3a1 1 0 0 1 -1 1h-8v2h8a3 3 0 0 0 3-3v-3a1 1 0 0 1 1-1h3v-2h-3a3 3 0 0 0 -3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 58v1a1 1 0 0 1 -1 1h-4v2h4a3 3 0 0 0 3-3v-1a1 1 0 0 1 1-1h7v-2h-7a3 3 0 0 0 -3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 16h18a4 4 0 0 0 0-8 3.88 3.88 0 0 0 -.684-2.156 4 4 0 0 0 -2.685-1.794 3.938 3.938 0 0 0 -2.36.349 7 7 0 0 0 -12.2 3.601h-.071a4 4 0 0 0 0 8zm0-6h1a1 1 0 0 0 1-1 5 5 0 0 1 9.2-2.709 1 1 0 0 0 1.5.21 1.979 1.979 0 0 1 1.623-.476 2.036 2.036 0 0 1 1.326.916 1.78 1.78 0 0 1 .23 1.724 1 1 0 0 0 .937 1.335h1.184a2 2 0 0 1 0 4h-18a2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 16h18a4 4 0 0 0 0-8h-.071a7 7 0 0 0 -12.2-3.6 3.917 3.917 0 0 0 -2.36-.349 4 4 0 0 0 -2.684 1.794 3.88 3.88 0 0 0 -.685 2.155 4 4 0 0 0 0 8zm0-6h1.184a1 1 0 0 0 .942-1.335 1.78 1.78 0 0 1 .23-1.724 2.036 2.036 0 0 1 1.326-.916 1.979 1.979 0 0 1 1.623.476 1 1 0 0 0 1.5-.21 5 5 0 0 1 9.195 2.709 1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-18a2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 36v-18h-2v18a3 3 0 0 0 3 3h7v-2h-7a1 1 0 0 1 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 37h-7v2h7a3 3 0 0 0 3-3v-18h-2v18a1 1 0 0 1 -1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridappdevelopment);
export default __webpack_public_path__ + "static/media/hybridappdevelopment.5f4b5367bbf5d4182ff5e702f50bd402.svg";
export { ForwardRef as ReactComponent };